import "core-js/modules/es.string.link.js";
import styled from "styled-components";
import { Link } from "@pochta/ui"; // Костыль c !important для pochta.ru, где стили заданы на теги и перебивает плоские классы
// TODO Убрать !important

var HeaderLink = styled(Link).withConfig({
  displayName: "HeaderLink",
  componentId: "sc-1n5q7tf-0"
})(["font-family:inherit;color:", " !important;&:visited{color:", " !important;}&:hover{color:", " !important;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.color.text.black.base;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.text.black.base;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.text.link.hover;
});
export default HeaderLink;